import { createContext, useContext, useEffect, useState } from "react";
import { analytics, auth } from "../firebase";
import {
  GoogleAuthProvider,
  User,
  signInWithPopup,
  signOut,
} from "firebase/auth";
import { logEvent } from "firebase/analytics";

export const UserContext = createContext<UserContextType>({
  currentUser: null,
  signIn: () => Promise.resolve(),
  signOutCallToAction: () => Promise.resolve(),
});

interface UserContextType {
  currentUser: User | null;
  signIn: () => Promise<void>;
  signOutCallToAction: () => Promise<void>;
}

export const UserProvider = ({ children }: any) => {
  const [currentUser, setCurrentUser] = useState<User | null>(null);
  const provider = new GoogleAuthProvider();

  useEffect(() => {
    auth.onAuthStateChanged(function (user) {
      if (user) {
        setCurrentUser(user);
      } else {
        setCurrentUser(null);
      }
    });
  }, []);

  const signIn = async () => {
    signInWithPopup(auth, provider)
      .then((result) => {
        const user = result.user;
        setCurrentUser(user);
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        const email = error.customData.email;
        const credential = GoogleAuthProvider.credentialFromError(error);

        throw new Error(errorCode + errorMessage + email + credential);
      });
  };
  const signOutCallToAction = async () => {
    signOut(auth)
      .then((result) => {
        if (analytics) {
          logEvent(analytics, "logout", { user: currentUser?.email });
        }
        setCurrentUser(null);
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        const email = error.customData.email;
        const credential = GoogleAuthProvider.credentialFromError(error);

        throw new Error(errorCode + errorMessage + email + credential);
      });
  };

  return (
    <UserContext.Provider value={{ currentUser, signIn, signOutCallToAction }}>
      {children}
    </UserContext.Provider>
  );
};

export const useCurrentUser = () => useContext(UserContext);
